import React, { useCallback } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { bigBrainTrack } from '../../services/bigbrain-service';
import bigBrainEvents from '../../constants/bigbrain-events';
import { openContactSupportModal } from '../../services/monday-service';
import DefaultErrorComponent from './default-error-component/default-error-component';

export default function withError(WrappedComponent) {
  return React.memo((props) => {
    const onError = useCallback((error, info) => {
      bigBrainTrack(bigBrainEvents.COMPONENT_ERROR, {
        info1: WrappedComponent.name,
        info2: JSON.stringify(error.message).substring(0, 500),
        info3: JSON.stringify(info.componentStack || {}).substring(0, 500),
      });
    }, []);

    const onContactSupportClicked = useCallback(() => {
      openContactSupportModal();
    }, []);

    return (
      <ErrorBoundary
        onError={onError}
        FallbackComponent={() => <DefaultErrorComponent onContactSupportClicked={onContactSupportClicked} />}
      >
        <WrappedComponent {...props} />
      </ErrorBoundary>
    );
  });
}
